<template>
  <div v-if="items && items.length">
    <b-table
      v-if="!isMobile"
      id="tbl-editorial-ranking-log"
      striped
      hover
      small
      class="datatable table-responsive"
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="1"
    >
      <template #cell(date)="data">
        <span v-shtml="data.value" />
      </template>
      <template #cell(staffUser)="{ item }">
        <staff-user-label :info="item.staffUser">
          User
        </staff-user-label>
      </template>
      <!-- [ID-338] Log entry: shows ranking transition and the reason -->
      <template #cell(data)="{ item }">
        <span v-shtml="formatChange(item)" />
      </template>
      <template #bottom-row="">
        <b-pagination
          v-model="currentPage"
          class="p-1 my-0"
          :total-rows="total"
          :per-page="perPage"
          aria-controls="tbl-editorial-ranking-log"
        />
      </template>
    </b-table>
    <div v-else>
      <timeline :items="items">
        <template #default="{ data: { item } }">
          <h5 class="fw-bold">
            {{ item.created_at ? $dateFormat(item.created_at, 'DD/MM/YYYY HH:mm') : '' }}
          </h5>
          <p class="text-muted mb-2 fw-bold">
            <staff-user-label :info="item.staffUser">
              User
            </staff-user-label>
          </p>
          <p v-shtml="formatChange(item)" class="p-0 text-muted" />
        </template>
      </timeline>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StaffUserLabel from '@/components/forms/CustomerEditForm/Elements/Logs/StaffUserLabel.vue'

export default {
  name: 'EditorialRankingLog',
  components: { StaffUserLabel },
  props: {
    itemId: {
      type: [String, Number],
      required: true
    },
    idx: {
      type: Number,
      default: -1
    },
    items: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      sortBy: 'date',
      sortDesc: true,
      currentPage: this.pagination?.current_page || 1,
      fields: [
        {
          key: 'date',
          label: this.$t('fCustomer_editorialRankingLog_f_date'),
          sortable: false,
          tdClass: 'col-2 text-left',
          formatter: (value, key, item) => {
            return item?.created_at
              ? this.$dateFormat(item.created_at, 'DD/MM/YYYY<br>HH:mm')
              : ''
          }
        },
        {
          key: 'staffUser',
          label: this.$t('fCustomer_editorialRankingLog_f_staff'),
          sortable: false,
          formatter: (value) => {
            return value ? `${value.email}&nbsp;(Id:&nbsp;${value.id})` : '—'
          }
        },
        {
          key: 'data',
          label: this.$t('fCustomer_editorialRankingLog_f_data')
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'device'
    }),
    isMobile () {
      return this.deviceInfo?.type === 'mobile' || false
    },
    total () {
      return this.pagination?.total || 0
    },
    perPage () {
      return this.pagination?.per_page || 10
    }
  },
  watch: {
    currentPage (p) {
      if (p && p !== (this.pagination?.current_page || 1)) {
        this.$emit('goToPage', p)
      }
    }
  },
  methods: {
    // [ID-338] Formats the context JSON into a human-readable change description.
    // context shape: { from: 'OLD_RANKING', to: 'NEW_RANKING' }
    formatChange (item) {
      const from = item?.context?.from || '—'
      const to = item?.context?.to || '—'
      const reason = item?.reason || ''
      const fromText = item?.context?.from ? `'${from}' ` : ''
      return `
        <small class="text-muted">Ranking ${fromText}changed to '${to}'</small><br>
        "${reason}"`
    }
  }
}
</script>

<style scoped>

</style>
